import { useAppDispatch } from 'app/hooks';
import Select from 'components/inputs/select';
import { ExistingSystemType } from 'data/types';
import { setDuctedPairLink } from 'features/configurations';

type DuctedPairLinkSelectProps = Readonly<{
  configurationId: string;
  condenserId: string;
  value: string | null;
  eligibleSystems: readonly ExistingSystemType[];
  takenSystemIds: ReadonlySet<string>;
  disabled?: boolean;
}>;

export default function DuctedPairLinkSelect({
  configurationId,
  condenserId,
  value,
  eligibleSystems,
  takenSystemIds,
  disabled = false
}: DuctedPairLinkSelectProps) {
  const dispatch = useAppDispatch();
  const options = eligibleSystems.map((system) => ({
    label: system.name || 'Existing System',
    value: system.uniqueId,
    disabled: takenSystemIds.has(system.uniqueId)
  }));

  return (
    <Select
      aria-label='Existing system for this pair'
      size='sm'
      placeholder='Link to an existing system...'
      value={value ?? ''}
      options={options}
      disabled={disabled || eligibleSystems.length === 0}
      invalid={value === null}
      onChange={(next) =>
        dispatch(
          setDuctedPairLink({
            configurationId,
            condenserId,
            existingSystemId: next === '' ? null : String(next)
          })
        )
      }
    />
  );
}
